import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../../components/displaycard';

import Auth from '../../../data/auth-service';
import Permissions from '../../../data/permissions';

const policies = [
    {
        title: 'Suricata Rules',
        description: 'Manage Suricata groups, rules, and settings',
        img: '/images/suricata-rules.jpg',
        route: '/policies/suricata/rules',
        perm: {
            SuricataRulesPolicy: [...Permissions.Policies.Suricata.SuricataRulesPolicy],
            SuricataRules: [...Permissions.Policies.Suricata.SuricataRules],
        },
    },
    {
        title: 'Suricata Vars',
        description: 'Modify Suricata variables',
        img: '/images/suricata-vars.jpg',
        route: '/policies/suricata/vars',
        perm: { SuricataVarsPolicy: [...Permissions.Policies.Suricata.SuricataVarsPolicy] },
    },
];

const PolicySuricata = (props) => {
    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {policies.filter(o => Auth.perm(o.perm)).map((p, i) => {
                    return (
                        <Grid item xl={3} lg={4} key={`policies-zeek-${i}`}>
                            <DisplayCard aria-label={p} {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default PolicySuricata;
